<template>
  <div class="global-alert-container">
    <v-alert
      v-for="alert in alerts"
      :key="alert.id"
      :type="alert.type"
      outlined
      dense
      dismissible
      class="global-alert-item"
      @input="removeAlert(alert.id)"
    >
      <div class="d-flex flex-column">
        <div
          v-if="alert.title"
          class="font-weight-medium mb-1 global-alert-item__title"
        >
          {{ alert.title }}
        </div>
        <div
          v-if="alert.message"
          class="text-body-2 white-space-pre-line global-alert-item__message"
        >
          {{ alert.message }}
        </div>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GlobalAlert',
  computed: {
    ...mapGetters('commonAlert', ['alerts'])
  },
  methods: {
    ...mapActions('commonAlert', ['removeAlert']),
  }
};
</script>

<style scoped>
.global-alert-container {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  min-width: 300px;
  max-width: calc(100% - 32px);
  z-index: 2000;
}

.fade-y-enter-active,
.fade-y-leave-active {
  transition: opacity var(--solvit-motion-duration) var(--solvit-motion-easing),
    transform var(--solvit-motion-duration) var(--solvit-motion-easing);
}

.fade-y-enter {
  opacity: 0;
  transform: translateY(-12px);
}

.fade-y-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
</style>

<style lang="scss">
/*
 * v-alert type + 기본 filled + theme.dark 조합이 다크에서 형광 배경·흰 글자로 대비가 나빠짐.
 * outlined + 테마별 토큰으로 본문/아이콘/닫기 버튼 대비 통일.
 */
.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined {
  background-color: var(--v-surface-base) !important;
  color: var(--v-text-base) !important;
}

.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined .global-alert-item__title,
.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined .global-alert-item__message {
  color: var(--v-text-base) !important;
}

.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined.v-alert--success {
  border-color: rgba(129, 199, 132, 0.65) !important;
  box-shadow: inset 3px 0 0 0 rgba(129, 199, 132, 0.85);
}

.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined.v-alert--error {
  border-color: rgba(248, 113, 113, 0.55) !important;
  box-shadow: inset 3px 0 0 0 rgba(248, 113, 113, 0.75);
}

.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined.v-alert--info {
  border-color: rgba(96, 165, 250, 0.55) !important;
  box-shadow: inset 3px 0 0 0 rgba(96, 165, 250, 0.75);
}

.v-application.theme--dark .global-alert-container .global-alert-item.v-alert--outlined.v-alert--warning {
  border-color: rgba(251, 191, 36, 0.55) !important;
  box-shadow: inset 3px 0 0 0 rgba(251, 191, 36, 0.75);
}

.v-application.theme--dark .global-alert-container .global-alert-item .v-alert__dismissible .v-icon,
.v-application.theme--dark .global-alert-container .global-alert-item .v-alert__icon.v-icon {
  color: var(--v-text-base) !important;
  opacity: 0.85;
}

.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined {
  background-color: var(--v-surface-base) !important;
  color: var(--v-text-base) !important;
}

.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined .global-alert-item__title,
.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined .global-alert-item__message {
  color: var(--v-text-base) !important;
}

.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined.v-alert--success {
  border-color: rgba(46, 125, 50, 0.45) !important;
  box-shadow: inset 3px 0 0 0 rgba(46, 125, 50, 0.65);
}

.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined.v-alert--error {
  border-color: rgba(211, 47, 47, 0.45) !important;
  box-shadow: inset 3px 0 0 0 rgba(211, 47, 47, 0.55);
}

.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined.v-alert--info {
  border-color: rgba(21, 101, 192, 0.45) !important;
  box-shadow: inset 3px 0 0 0 rgba(21, 101, 192, 0.55);
}

.v-application.theme--light .global-alert-container .global-alert-item.v-alert--outlined.v-alert--warning {
  border-color: rgba(239, 108, 0, 0.45) !important;
  box-shadow: inset 3px 0 0 0 rgba(239, 108, 0, 0.55);
}

.v-application.theme--light .global-alert-container .global-alert-item .v-alert__dismissible .v-icon,
.v-application.theme--light .global-alert-container .global-alert-item .v-alert__icon.v-icon {
  color: var(--v-text-base) !important;
  opacity: 0.75;
}
</style>

